import { render, staticRenderFns } from "./ManagerEventCreateAndUpdateFormItems.vue?vue&type=template&id=6ea5c60e&"
import script from "./ManagerEventCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./ManagerEventCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports